import { FormControlContext } from './form-control-context';

const FormControl = (props) => {
  const {
    children,
    component: Component = 'div',
    disabled = false,
    error = false,
    mode = 'edit',
    readOnly = false,
    required = false,
  } = props;

  const isReadOnly = mode === 'view' || readOnly;

  const childContext = {
    disabled,
    error,
    readOnly: isReadOnly,
    required,
  };

  return (
    <FormControlContext.Provider value={childContext}>
      <Component>{children}</Component>
    </FormControlContext.Provider>
  );
};

export { FormControl, FormControlContext };
export { useFormControl } from './use-form-control';
export { formControlState } from './form-control-state';
